<template>
  <div class="container">
    <p>やまなしデータプラットフォーム</p>
  </div>
</template>

<style scoped>
.container {
  width: 100%;
  aspect-ratio: 87/13;
  background-image: url("../assets/image/topImage.jpg");
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.container > p {
  position: absolute;
  font-size: 4vw;
  font-weight: 900;
  color: white;
}

.container::before {
  content: "";
  /* ↓暗いオーバーレイを半透明で配置 */
  background-color: rgba(0, 0, 0, 0.4);
  /* ↓全体を覆うように配置 */
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: block;
}
</style>
